import React from "react";
import { Map, MapDrawer, NavigationControl } from "../Mapbox";

const mapboxToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

const MAP_OPTIONS_DEFAULT = {
  center: [77.66, 23.53] as [number, number],
  zoom: 3,
  style: "mapbox://styles/mapbox/streets-v11",
};

interface DrawMapProps {
  accessToken?: string;
  mapStyle?: string;
  value: any;
  navigation?: boolean;
}

const ViewMap: React.FC<DrawMapProps> = ({
  accessToken = mapboxToken || "",
  mapStyle,
  value,
  navigation = true,
}) => {
  return (
    <div className="w-full h-full">
      <Map
        accessToken={accessToken}
        options={{
          center: MAP_OPTIONS_DEFAULT.center,
          zoom: MAP_OPTIONS_DEFAULT.zoom,
          style: mapStyle || MAP_OPTIONS_DEFAULT.style,
        }}
      >
        {navigation && <NavigationControl position="top-right" />}
        <MapDrawer
          position="top-left"
          options={{
            displayControlsDefault: false,
          }}
          value={value}
        />
      </Map>
    </div>
  );
};

export default ViewMap;
